import type Immutable from 'immutable';
import { createAction } from '@reduxjs/toolkit';

import type { BrandKit } from 'js/src/client';
import { BRAND_KIT_ACTIONS } from 'js/src/data/brand-kits/brand-kits-types';
import type { ImmutableMap } from 'js/src/libs/consts';

export const setBrandKitsLoading = createAction<{
    flag: boolean;
}>(BRAND_KIT_ACTIONS.SET_BRAND_KITS_LOADING);

export const storeBrandKits = createAction<{
    brandKits: Immutable.List<ImmutableMap<BrandKit>>;
}>(BRAND_KIT_ACTIONS.STORE_BRAND_KITS);

export const setSelectedBrandKitId = createAction<number>(
    BRAND_KIT_ACTIONS.SET_SELECTED_BRAND_KIT_ID,
);

export const setTeamBrandKitsCount = createAction<number>(
    BRAND_KIT_ACTIONS.SET_TEAM_BRAND_KITS_COUNT,
);
